module.exports = __webpack_public_path__ + "static/media/dcp-logo.79c4fe75.svg";